import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Grid } from "@mui/material";
import { Link } from "react-router-dom";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

function PreviousYearDocuments() {
  const [items, setItems] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [limit, setLimit] = useState(20);
  const [pagination, setPagination] = useState({});
  const [notification, setNotification] = useState({ open: false, color: "success", message: "" });

  const showMessage = (message, color = "success") => {
    setNotification({ open: true, color, message });
    setTimeout(() => setNotification({ open: false, color, message: "" }), 2500);
  };

  const loadItems = async (page = pageNo, currentLimit = limit) => {
    if (init() !== "success") return;
    try {
      const resp = await axios.get(
        `${Constants.getUrls.getAllPreviousYearDocuments}?page=${page}&limit=${currentLimit}`
      );
      setItems(resp?.data?.data?.docs || []);
      setPagination(resp?.data?.data || {});
      setPageNo(resp?.data?.data?.page || page);
      setLimit(resp?.data?.data?.limit || currentLimit);
    } catch (error) {
      showMessage(error?.response?.data?.message || "Unable to load previous year documents.", "error");
    }
  };

  useEffect(() => {
    loadItems(1, limit);
  }, []);

  const handleDelete = async (id) => {
    try {
      const resp = await axios.delete(`${Constants.deleteUrls.deletePreviousYearDocument}${id}`);
      showMessage(resp?.data?.message || "Previous year document deleted successfully.");
      loadItems(pageNo, limit);
    } catch (error) {
      showMessage(error?.response?.data?.message || "Unable to delete previous year document.", "error");
    }
  };

  const rows = items.map((item, index) => ({
    serial: (pageNo - 1) * limit + index + 1,
    scope: item?.document_scope === "subject" ? "Subject Wise" : "Exam Wise",
    linked_to:
      item?.document_scope === "subject"
        ? [item?.subject_id?.subject_name, item?.topic_id?.topic_name].filter(Boolean).join(" • ") || "-"
        : item?.exam_id?.exam_name || "-",
    year_or_topic:
      item?.document_scope === "subject"
        ? item?.topic_id?.topic_name || "-"
        : item?.year_id?.year || "-",
    document: item?.document ? (
      <a href={`${Constants.imageDomain}${item.document}`} target="_blank" rel="noreferrer">
        {item?.document_title || "Open PDF"}
      </a>
    ) : (
      "-"
    ),
    questions: item?.questions || 0,
    active: item?.active ? "Yes" : "No",
    downloadable: item?.downloadable ? "Yes" : "No",
    action: (
      <MDBox display="flex" gap={1}>
        <Link to={`/update-previous-year-document/${item._id}`}>
          <MDButton variant="outlined" size="small" color="info">
            Update
          </MDButton>
        </Link>
        <MDButton
          variant="outlined"
          size="small"
          color="error"
          onClick={() => handleDelete(item._id)}
        >
          Delete
        </MDButton>
      </MDBox>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
            <MDTypography variant="h6" color="white">
              PDF Resources
            </MDTypography>
          </MDBox>
          <Grid item sm={4} px={2} py={2} align="right">
            <Link to="/add-previous-year-document">
              <MDButton variant="contained" size="small" color="primary">
                Add PDF Resource
              </MDButton>
            </Link>
          </Grid>
          <MDBox>
            <DataTable
              table={{
                columns: [
                  { Header: "serial", accessor: "serial", width: "6%" },
                  { Header: "Scope", accessor: "scope" },
                  { Header: "Linked To", accessor: "linked_to" },
                  { Header: "Year / Topic", accessor: "year_or_topic" },
                  { Header: "Document", accessor: "document" },
                  { Header: "Questions", accessor: "questions" },
                  { Header: "Active", accessor: "active" },
                  { Header: "Downloadable", accessor: "downloadable" },
                  { Header: "Action", accessor: "action" },
                ],
                rows,
              }}
              entriesPerPage={{ defaultValue: limit, entries: [10, 25, 50, 100] }}
              page_no={pagination?.page}
              totalPages={pagination?.totalPages}
              hasNextPage={pagination?.hasNextPage}
              hasPrevPage={pagination?.hasPrevPage}
              isnextPage={pagination?.nextPage}
              prevPage={pagination?.prevPage}
              totalDocs={pagination?.totalDocs}
              onPageChange={(page) => loadItems(page, limit)}
              onEntriesPerPageChange={(newLimit) => loadItems(1, newLimit)}
            />
          </MDBox>
          <MDSnackbar
            color={notification.color}
            icon="notifications"
            title="AgriQuiz"
            content={notification.message}
            dateTime="Just now"
            open={notification.open}
          />
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default PreviousYearDocuments;
